export const PRIVACY_MODULE_ROLES = ['ADMIN', 'DPO']

export function getSessionRoles(token = localStorage.getItem('token')) {
  if (!token) return []
  try {
    const parts = token.split('.')
    if (parts.length !== 3) return []
    const payload = JSON.parse(atob(parts[1]))
    return Array.isArray(payload.roles) ? payload.roles : []
  } catch {
    return []
  }
}

export function canAccessPrivacyModule(roles = getSessionRoles()) {
  return (roles || []).some((role) => PRIVACY_MODULE_ROLES.includes(role))
}
